import { styled } from '@uhg-abyss/web/tools/styled';
import { DropdownMenu } from '@uhg-abyss/web/ui/DropdownMenu';
import { Flex } from '@uhg-abyss/web/ui/Flex';

export const DropdownMenuButton = styled(DropdownMenu, {
  '&.abyss-dropdown-menu-trigger-root': {
    color: '$descriptionBlack',
    fontWeight: '600',
    borderRadius: '24px',
    height: '1.525em',
    fontSize: '$md',
    padding: '$sm $md $sm $lg',
    border: '1px solid $core.color.neutral.30',
    '@media (max-width: 464px)': {
      color: '$core.color.brand.100',
      border: '1px solid $core.color.brand.100',
    },
  },
  '&.abyss-dropdown-menu-radio-group-label': {
    padding: '$lg $lg $sm $lg',
  },
  '&.abyss-dropdown-menu-content': {
    height: 300,
    width: 300,
    borderRadius: 12,
    boxShadow: '0px 4px 16px 0px $descriptionBlack',
  },
  '&.abyss-dropdown-menu-radio': {
    '&[data-state="checked"]': {
      color: '$neutralGray7',
      fontWeight: 'bold',
      paddingLeft: 26,
    },
    fontSize: '$lg',
    paddingLeft: 26,
    paddingTop: 24,
  },
});

export const ChipMenuIcon = styled('div', {
  display: 'inline-flex',
  '@media (max-width: 744px)': {
    marginRight: '8px',
  },
  '@media (min-width: 745px)': {
    marginRight: '12px',
  },
});

export const ChipFiltersContainer = styled('div', {
  variants: {
    showAll: {
      true: {
        '&.hide-scrollbar': {
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
        },
      },
      false: {
        '&.hide-scrollbar': {
          display: 'inline-flex',
          overflow: 'auto',
          scrollBehavior: 'smooth',
        },
      },
    },
  },
  '@media (max-width: 744px)': {
    gap: '8px',
  },
  '@media (min-width: 745px)': {
    gap: '12px',
  },
  scrollbarColor: 'transparent transparent' /* Hide scrollbar for Firefox */,
  /**
   * This CSS class override div styled + add pseudo class to hide the horizontal scrollbar,
   * but keep its functionality.
   * Only for this div container.
   * */
  '&.hide-scrollbar::-webkit-scrollbar': {
    display: 'none' /* Hide scrollbar for Chrome, Safari and Opera */,
  },
  button: {
    overflow: 'initial',
  },
});

export const Wrapper = styled(Flex, {
  display: 'flex',
  flexWrap: 'nowrap',
  alignItems: 'flex-start',
  '&.abyss-flex-content-root	': {
    padding: '0 !important',
    marginBottom: '0 !important',
  },
});
